<template>
  <div class="flex">
    <vx-tooltip :text="params.data.alertState.length > 0 ? params.data.alertState.join(', ') : 'Ok'" position="bottom">
      <feather-icon class="mr-2" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (params.data.alertState.length > 0 ? 'text-danger' : 'text-success')]" />
    </vx-tooltip>
    <span>{{ stateLabel(params.value) }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    stateLabel () {
      if (this.params.data.logisticType === 'Entrega') {
        return (value) => {
          if (this.params.data.isTracking || (this.params.data.hasTracking && value !== 'delivered')) return 'Rastreando'
          if (value === 'custody') return 'Aguardando envio'
          else if (value === 'delivered') return 'Entregue'
          else if (value === 'transit') return 'Em rota de entrega'
          else return 'warning'
        }
      } else {
        return (value) => {
          if (this.params.data.isTracking || (this.params.data.hasTracking && value !== 'delivered')) return 'Rastreando'
          if (value === 'custody') return 'Aguardando coleta'
          else if (value === 'delivered') return 'Recebido'
          else if (value === 'transit') return 'Em rastreamento'
          else return 'warning'
        }        
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
